import Tasks from "./Tasks";
import Orderbook from "./Orderbook";
import AddTaskBox from "./Add/AddTaskBox";
import TablesWrapper from "./TablesWrapper/TablesWrapper";
import ReferenceTable from "../../Tables/DeltaHedgeMarketmaking/Reference/ReferenceTable";
import Button from "../../Components/Button";
import { useState } from "react";
import Modal from "../../Components/Modal/Modal";
import ManualConfig from "./ManualConfig";

const Marketmaking = () => {
  const [isManualConfigOpen, setIsManualConfigOpen] = useState(false);

  return (
    <div className="flex flex-col justify-start items-start gap-1 px-4 mt-8 h-[90vh] overflow-y-auto">
      {isManualConfigOpen ? (
        <Modal
          onClose={() => setIsManualConfigOpen(false)}
          UI={<ManualConfig onClose={() => setIsManualConfigOpen(false)} />}
        />
      ) : (
        <></>
      )}

      <div className="flex flex-row justify-start items-start gap-3 w-full h-auto">
        <div className="min-w-max w-full h-max">
          <Tasks />
        </div>
        <div className="flex flex-col justify-start items-start">
          <div className="w-min h-max">
            <Orderbook />
          </div>
          <div className="w-min h-max">
            <ReferenceTable />
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-start items-start gap-3 w-full h-auto">
        <div className="flex flex-col justify-start items-start gap-3">
          <AddTaskBox />
          <Button
            text="نتظیم دستی"
            variant="outlined"
            onClick={() => setIsManualConfigOpen(true)}
          />
        </div>
        <div className="w-full h-full flex flex-col justify-start items-start gap-3">
          <TablesWrapper />
        </div>
      </div>
    </div>
  );
};

export default Marketmaking;
